/* global customElements, HTMLElement */

class TestimonialCard extends HTMLElement {
  connectedCallback () {
    this.$button = this.querySelector('[data-testimonial-toggle]')
    this.$content = this.querySelector('[data-testimonial-content]')

    if (!this.$button || !this.$content) {
      return
    }

    this.$button.addEventListener('click', () => this.toggle())
  }

  get $$otherCards () {
    return [...document.querySelectorAll('testimonial-card')].filter(card => card !== this)
  }

  toggle (force = null) {
    if (!this.$button) {
      return
    }

    const oldState = this.$button.getAttribute('aria-expanded') === 'true'
    const newState = typeof force === 'boolean' ? force : !oldState

    if (newState === oldState) {
      return
    }

    if (newState) {
      this.$$otherCards.forEach($card => {
        if ($card.$button) {
          $card.toggle(false)
        }
      })
    }

    this.$button.setAttribute('aria-expanded', newState)
    this.$content.setAttribute('aria-hidden', !newState)
  }
}

customElements.define('testimonial-card', TestimonialCard)
